<template>
  <div id="app">
    <component :is="dynamicComp" :data="data" />
  </div>
</template>

<script>
import axios from "axios";
import MapApp from "./components/map/mapApp.vue";
import MapLoading from "./components/map/mapLoading.vue";

export default {
  name: "mapapp",
  data() {
    return {
      data: {},
	  fetchingData: true,
	  dynamicComp: '',
    };
  },

  created() {
	this.dynamicComp = MapLoading

	console.log('process.env.NODE_ENV', process.env.NODE_ENV)
    // api request
    let apiEndpoint = process.env.NODE_ENV === 'development' ? 'https://visitnewcastle-dev.uat.webcoda.net.au/' : '/'
	let nodeId = window.itineraryNodeId;
	let request = `${apiEndpoint}Api/ListApi/GetItineraryHighlights?nodeid=${nodeId}`
	console.log('request url: ', request)

    axios({
	  method: 'GET',
	  url: request,
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json'
      },
      redirect: 'follow',
      referrer: 'no-referrer'
    })
      .then(response => {
        if (response.status === 200) {
          this.data = response.data
		  this.fetchingData = false
		  setTimeout(() => {
			  this.dynamicComp = MapApp
		  }, 1000)
        } else {
          throw new Error("Something went wrong on api server!")
        }
      })
      .catch(error => {
        console.info(error)
      });
  },

  components: {
    MapApp,
    MapLoading
  }
};
</script>

<style lang="scss">
// @import "./assets/styles.css";

html,
body {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
}

#app {
  height: 100%;
  padding-top: 60px;

  @media (min-width: 768px) {
	  padding-top: 72px;
  }
}
</style>
